import { ref } from 'vue'

/**
 * Calculates the width of the browser scrollbar
 * If not in browser, returns 0
 * @returns {width: Ref<number>}
 */
export const useScrollbarWidth = () => {
  const width = ref(0)
  if (window && document) {
    width.value = window.innerWidth - document.documentElement.clientWidth
  }
  return { width }
}
